import React from "react";
import ReactDOM from "react-dom";
import $ from 'jquery';
import {Reviews} from "./src/reviews";
import {Create} from "./src/create";

export class ProductReviewsWidget extends React.Component {
	render() {
		const {source, target, token, id} = this.props;
		return (
			<div className="product--reviews">
				<Reviews source={source} />
				<Create id={id} target={target} token={token} />
			</div>
		);
	}

	static attachTo(element) {
		const id = $(element).data('id');
		const token = $(element).data('token');
		const source = $(element).data('source');
		const target = $(element).data('target');
		ReactDOM.render(<ProductReviewsWidget id={id} token={token} source={source} target={target} />, element);
	}
}
